var _path, _path2, _path3, _path4, _path5;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDistribution(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59608 15.48C4.85996 15.48 5.88454 14.4771 5.88454 13.24C5.88454 12.0029 4.85996 11 3.59608 11C2.3322 11 1.30762 12.0029 1.30762 13.24C1.30762 14.4771 2.3322 15.48 3.59608 15.48Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4037 5.1198C14.6676 5.1198 15.6922 4.11692 15.6922 2.8798C15.6922 1.64268 14.6676 0.639801 13.4037 0.639801C12.1398 0.639801 11.1152 1.64268 11.1152 2.8798C11.1152 4.11692 12.1398 5.1198 13.4037 5.1198Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59608 5.1198C4.85996 5.1198 5.88454 4.11692 5.88454 2.8798C5.88454 1.64268 4.85996 0.639801 3.59608 0.639801C2.3322 0.639801 1.30762 1.64268 1.30762 2.8798C1.30762 4.11692 2.3322 5.1198 3.59608 5.1198Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5957 10.24V9.59998C3.59571 9.09078 3.80237 8.60244 4.17023 8.24239C4.53808 7.88233 5.03699 7.68005 5.5572 7.68005L11.4419 7.67994C11.9621 7.67994 12.461 7.47766 12.8289 7.1176C13.1967 6.75755 13.4034 6.26921 13.4034 5.76001V5.12",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.5957 5.12V11",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDistribution);
export default __webpack_public_path__ + "static/media/distribution.804806968982ab013cb656786cfafb98.svg";
export { ForwardRef as ReactComponent };